module.exports = __webpack_public_path__ + "static/chair1-d8486760f2f348c48523ad86426a52b3.jpg";